import { VFC, useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { DiameterNominal } from '@enmon/commons';
import { Select } from '../Select';
import { MeterDetails as messages } from '../../Form/meter_details/messages';
import { diameterNominalTranslated } from '../../Form/meter_details/constants';
import { useMeterModelSuggestionsStore } from '../../../store/useMeterModelSuggestionsStore';
import { getSelectOptionsWithSuggestions } from '../utils/getSelectOptionsWithSuggestions';

interface DiameterNominalSelectProps {
  value?: DiameterNominal;
  onChange?: (value: DiameterNominal) => void;
}

export const DiameterNominalSelect: VFC<DiameterNominalSelectProps> = ({ ...restProps }) => {
  const intl = useIntl();
  const { meterModelSuggestions } = useMeterModelSuggestionsStore();

  const diameterNominalOptions = useMemo(
    () =>
      getSelectOptionsWithSuggestions({
        intl,
        values: Object.values(DiameterNominal),
        suggestedValue: meterModelSuggestions?.diameterNominal?.value,
        suggestedSelection: meterModelSuggestions?.diameterNominal?.selection,
        labelFormatter: (value: DiameterNominal) => diameterNominalTranslated[value],
      }),
    [intl, meterModelSuggestions],
  );

  return (
    <Select
      allowClear
      showArrow
      className="w-100"
      options={diameterNominalOptions}
      placeholder={<FormattedMessage {...messages.diameterDimensionNominalPlaceholder} />}
      {...restProps}
    />
  );
};
